const PersistentStorage = {
  setLocalData(name: string, value: any): void {
    if (typeof window !== 'undefined') {
      localStorage.setItem(name, JSON.stringify(value))
    }
  },

  getLocalData(key: string): any {
    if (typeof window !== 'undefined') {
      const value = localStorage.getItem(key)
      if (value == null) {
        return null
      }
      return JSON.parse(value)
    } else return null
  },

  removeLocalData(key: string): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(key)
    }
  },

  changeItemFromLocalData(key: string, name: string, value: any) {
    if (typeof window !== 'undefined') {
      const data = this.getLocalData(key) || {}
      const newData = {
        ...data,
        [name]: value,
      }
      this.setLocalData(key, newData)
    }
  },
}

export default PersistentStorage
